import { useBreakpoint } from '@/hooks/useBreakpoint';

import { SidebarDesktop } from '../SidebarDesktop';
import { SidebarMobile } from '../SidebarMobile';

export const Sidebar = () => {
    const isMin1024 = useBreakpoint('md');

    if (isMin1024) {
        return <SidebarDesktop />;
    }

    return <SidebarMobile />;
};
